import React from 'react';
import {
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Link,
  Box
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBack from '@mui/icons-material/ArrowBack';

export const Breadcrumbs: React.FC<{
  title?: string;
  breadcrumbs?: {
    active: string;
    links: { link?: string; title: string }[];
  };
}> = ({ title, breadcrumbs }) => (
  <Box>
    {breadcrumbs && (
      <MuiBreadcrumbs>
        <Link
          component={RouterLink}
          to="/"
          sx={{ textDecoration: 'none', display: 'flex' }}
        >
          <ArrowBack fontSize="small" sx={{ mr: 1 }} />
          Home
        </Link>
        {breadcrumbs.links.map((link, key) =>
          link.link ? (
            <Link
              component={RouterLink}
              key={key}
              to={link.link}
              style={{ textDecoration: 'none' }}
            >
              {link.title}
            </Link>
          ) : (
            <Typography key={key}>{link.title}</Typography>
          )
        )}
        <Typography>{breadcrumbs.active}</Typography>
      </MuiBreadcrumbs>
    )}
    <Typography variant="h2" component="h1" sx={{ mt: 1 }}>
      {title}
    </Typography>
  </Box>
);
